// Scroll the first invalid field into view after a failed submit, so a
// validation error above the fold never reads as a silent failure.
//
// base-input marks an errored field with .has-danger. Call this AFTER the
// error state has been set; it defers to the next frame so the class has
// rendered. Scope the search with a selector (e.g. '.base-drawer__body') so
// an errored field behind an overlay cannot win.
export function scrollToFirstError(scopeSelector = '') {
  const run = () => {
    if (typeof document === 'undefined') return
    const selector = scopeSelector ? `${scopeSelector} .has-danger` : '.has-danger'
    const el = document.querySelector(selector)
    if (el && typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }
  if (typeof requestAnimationFrame === 'function') requestAnimationFrame(run)
  else setTimeout(run, 0)
}
